<template>
  <ring-main>
    <router-view :key="$route.fullPath" />
  </ring-main>
</template>

<script>
import RingMain from "@/containers/Core/Main";
import store from "@/modules";

export default {
  name: "Customer",
  components: { RingMain },
  beforeRouteEnter(to, from, next) {
    if (
      to.params.customer_id.toString().match(/^\d+$/) ||
      to.params.customer_id.toString().match(/ring.account.([^&?\/]+)/)
    ) {
      getCustomerData(
        { customer_id: to.params.customer_id },
        { includes: [] },
        from,
        next
      );
    } else {
      next((vm) => {
        vm.$router.push({ name: "HomePage" });
        setTimeout(() => {
          vm.$notify.warning({
            title: `Id in url must be a customer ID (numeric)`,
            message: "Error",
            duration: 0,
          });
        }, 1000);
      });
    }
  },
  mounted: function () {
    if (document.getElementById("gPlacesScript_1") == null) {
      let googleApiPlaces = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&libraries=places&language=en-US`;
      let tag = document.createElement("script");
      tag.setAttribute("src", googleApiPlaces);
      tag.setAttribute("id", "gPlacesScript_1");
      document.head.appendChild(tag);
    }
  },
};

function getCustomerData({ customer_id }, { includes }, from, next) {
  try {
    const res = store
      .dispatch(
        "db/account/globalSearch",
        {
          criteria: customer_id,
          model: "Customer",
          includes,
        },
        { root: true }
      )
      .then(({ id }) => {
        if (String(id).match("#")) {
          const params = { customer_id: id };
          next((vm) => vm.$router.replace({ name: "CustomerProfile", params }));
        } else {
          next();
        }
      })
      .catch(() => {
        if (from.name === null) {
          next((vm) => vm.$router.push({ name: "HomePage" }));
        } else {
          next(false);
        }
      });
  } catch (e) {
    next(false);
    return e.data.message;
  }
  return true;
}
</script>

<style lang="scss"/>
